<template >
  <div class="main">
    <div id="an1" style="display:none">
      <div class="answerTitle">如何开通科创板</div>
      <div class="answerContet">在五矿手机证券APP中，点击“我的”-“业务办理”即可在线开通。</div>
      <div class="otherQuestion">其他问题</div>
      <div class="otherQuestionStr" @click="showDetail(2)">科创板的开通条件有哪些</div>
      <div class="otherQuestionStr" @click="showDetail(3)">科创板的交易规则是什么</div>
      <div class="bgspace"></div>
    </div>
    <div id="an2" style="display:none">
      <div class="answerTitle">科创板的开通条件有哪些</div>
      <div class="answerContet">
        1、参与证券交易24个月以上;
        <br />2、申请权限开通前20个交易日证券帐户及资金帐户内的资产日均不低于人民币50万元（不包含通过融资融券融入的资金和证券）。
        满足条件后，可在五矿手机证券APP中“业务办理”中自助开通。
      </div>
      <div class="otherQuestion">其他问题</div>
      <div class="otherQuestionStr" @click="showDetail(1)">如何开通科创板</div>
      <div class="otherQuestionStr" @click="showDetail(3)">科创板的交易规则是什么</div>
      <div class="bgspace"></div>
    </div>
    <div id="an3" style="display:none">
      <div class="answerTitle">科创板的交易规则是什么</div>
      <div class="answerContet">
        科创板单笔申报数量应当不少于200股；
        <br />竞价交易实行价格涨跌幅限制，涨跌幅比例为20%；
        <br />首次公开交易上市的股票，上市后的前5个交易日不设价格涨跌幅；
        <br />科创板股票不实行当日回转交易，投资者当日买入的科创板股票，在次一交易日才能卖出。买卖科创板股票，在连续竞价阶段提交限价申报应遵循不高于（低于）买入（卖出）基准价102（98%）等有效申报价格范围。
        <br />
      </div>
      <div class="otherQuestion">其他问题</div>
      <div class="otherQuestionStr" @click="showDetail(1)">如何开通科创板</div>
      <div class="otherQuestionStr" @click="showDetail(2)">科创板的开通条件有哪些</div>
      <div class="bgspace"></div>
    </div>

    <div id="an4" style="display:none">
      <div class="answerTitle">如何在五矿证券开户</div>
      <div class="answerContet">在五矿手机证券APP中，点击“我的”-“极速开户”即可在线开通证券账户。</div>
      <div class="otherQuestion">其他问题</div>
      <div class="otherQuestionStr" @click="showDetail(5)">已满三户，还能开户吗</div>
      <div class="otherQuestionStr" @click="showDetail(6)">自助开户成功后多久可以交易</div>
      <div class="bgspace"></div>
    </div>

    <div id="an5" style="display:none">
      <div class="answerTitle">已满三户，还能开户吗</div>
      <div class="answerContet">一个投资者在同一市场最多可以申请开立3个A股账户、3个封闭式基金账户。如您已开立3个同类型账户，可将已开立账户转户到我司交易。</div>
      <div class="otherQuestion">其他问题</div>
      <div class="otherQuestionStr" @click="showDetail(4)">如何在五矿证券开户</div>
      <div class="otherQuestionStr" @click="showDetail(6)">自助开户成功后多久可以交易</div>
      <div class="bgspace"></div>
    </div>

    <div id="an6" style="display:none">
      <div class="answerTitle">自助开户成功后多久可以交易</div>
      <div class="answerContet">上海、深圳均为T+1日生效。转户当天生效。</div>
      <div class="otherQuestion">其他问题</div>
      <div class="otherQuestionStr" @click="showDetail(4)">如何在五矿证券开户</div>
      <div class="otherQuestionStr" @click="showDetail(5)">已满三户，还能开户吗</div>
      <div class="bgspace"></div>
    </div>

    <div id="an7" style="display:none">
      <div class="answerTitle">如何开通港股通交易权限</div>
      <div class="answerContet">
        申请权限开通前20个交易日证券帐户及资金帐户内的资产日均不低于人民币50万元（不包含通过融资融券融入的资金和证券）。
        满足条件后，可在五矿手机证券APP中“业务办理”中自助开通。
      </div>
      <div class="otherQuestion">其他问题</div>
      <div class="otherQuestionStr" @click="showDetail(8)">如何开通风险警示板交易权限</div>
      <div class="otherQuestionStr" @click="showDetail(9)">如何开通退市交易权限</div>
      <div class="bgspace"></div>
    </div>

    <div id="an8" style="display:none">
      <div class="answerTitle">如何开通风险警示板交易权限</div>
      <div class="answerContet">
        申请权限开通前20个交易日证券帐户及资金帐户内的资产日均不低于人民币50万元（不包含通过融资融券融入的资金和证券）。
        满足条件后，可在五矿手机证券APP中“业务办理”中自助开通。
      </div>
      <div class="otherQuestion">其他问题</div>
      <div class="otherQuestionStr" @click="showDetail(7)">如何开通港股通交易权限</div>
      <div class="otherQuestionStr" @click="showDetail(9)">如何开通退市交易权限</div>
      <div class="bgspace"></div>
    </div>
    <div id="an9" style="display:none">
      <div class="answerTitle">如何开通退市交易权限</div>
      <div class="answerContet">
        申请权限开通前20个交易日证券帐户及资金帐户内的资产日均不低于人民币50万元（不包含通过融资融券融入的资金和证券）。
        满足条件后，可在五矿手机证券APP中“业务办理”中自助开通。
      </div>
      <div class="otherQuestion">其他问题</div>
      <div class="otherQuestionStr" @click="showDetail(7)">如何开通港股通交易权限</div>
      <div class="otherQuestionStr" @click="showDetail(8)">如何开通风险警示板交易权限</div>
      <div class="bgspace"></div>
    </div>
    <div id="an10" style="display:none">
      <div class="answerTitle">开盘价是什么</div>
      <div class="answerContet">证券的开盘价为当日该证券的第一笔成交价格。证券的开盘价通过集合竞价方式产生，不能产生开盘价的，以连续竞价方式产生。</div>
      <div class="otherQuestion">其他问题</div>
      <div class="otherQuestionStr" @click="showDetail(11)">收盘价是什么</div>
      <div class="otherQuestionStr" @click="showDetail(12)">股票9:30之前的集合竞价的交易规则是怎样的</div>
      <div class="otherQuestionStr" @click="showDetail(13)">股票开市收市时间是怎样的</div>
      <div class="otherQuestionStr" @click="showDetail(14)">为什么会有委托价和成交价不一致的情况</div>
      <div class="otherQuestionStr" @click="showDetail(15)">股票成交的时间优先、价格优先原则是指什么</div>
      <div class="otherQuestionStr" @click="showDetail(16)">市价委托和限价委托的区别是什么</div>
      <div class="otherQuestionStr" @click="showDetail(17)">为何委托后一直没有成交</div>
      <div class="otherQuestionStr" @click="showDetail(18)">什么情况下可以委托撤单</div>
      <div class="otherQuestionStr" @click="showDetail(19)">送股是什么</div>
      <div class="bgspace"></div>
    </div>

    <div id="an11" style="display:none">
      <div class="answerTitle">收盘价是什么</div>
      <div
        class="answerContet"
      >收盘价是指某种证券在证券交易所一天交易活动结束前最后一笔交易的成交价格。如当日没有成交，则采用最近一次的成交价格作为收盘价，因为收盘价是当日行情的标准，又是下一个交易日开盘价的依据，可据以预测未来证券市场行情；所以投资者对行情分析时，一般采用收盘价作为计算依据。</div>
      <div class="otherQuestion">其他问题</div>
      <div class="otherQuestionStr" @click="showDetail(10)">开盘价是什么</div>
      <div class="otherQuestionStr" @click="showDetail(12)">股票9:30之前的集合竞价的交易规则是怎样的</div>
      <div class="otherQuestionStr" @click="showDetail(13)">股票开市收市时间是怎样的</div>
      <div class="otherQuestionStr" @click="showDetail(14)">为什么会有委托价和成交价不一致的情况</div>
      <div class="otherQuestionStr" @click="showDetail(15)">股票成交的时间优先、价格优先原则是指什么</div>
      <div class="otherQuestionStr" @click="showDetail(16)">市价委托和限价委托的区别是什么</div>
      <div class="otherQuestionStr" @click="showDetail(17)">为何委托后一直没有成交</div>
      <div class="otherQuestionStr" @click="showDetail(18)">什么情况下可以委托撤单</div>
      <div class="otherQuestionStr" @click="showDetail(19)">送股是什么</div>
      <div class="bgspace"></div>
    </div>

    <div id="an12" style="display:none">
      <div class="answerTitle">股票9:30之前的集合竞价的交易规则是怎样的</div>
      <div class="answerContet">
        集合竞价确定成交价格的原则为：
        1、可实现最大成交量的价格；
        2、高于该价格的买入申报与低于该价格的卖出申报全部成交的价格；
        3、与该价格相同的买方或卖方至少有一方全部成交的价格。如有两个以上申报价格符合上述条件的，深交所取距前收盘价最近的价位为成交价；上交所则规定使未成交量最小的申报价格为成交价格，若有两个以上使未成交量最小的申报价格符合上述条件的，其中间价为成交价格。然后进行集中撮合处理。按照价格优先、同等价格下时间优先的成交顺序依次成交，直至成交条件不满足为止，即所有买入委托的限价均低于卖出委托的限价，所有成交都以同一成交价成交。
      </div>
      <div class="otherQuestion">其他问题</div>
      <div class="otherQuestionStr" @click="showDetail(10)">开盘价是什么</div>
      <div class="otherQuestionStr" @click="showDetail(11)">收盘价是什么</div>
      <div class="otherQuestionStr" @click="showDetail(13)">股票开市收市时间是怎样的</div>
      <div class="otherQuestionStr" @click="showDetail(14)">为什么会有委托价和成交价不一致的情况</div>
      <div class="otherQuestionStr" @click="showDetail(15)">股票成交的时间优先、价格优先原则是指什么</div>
      <div class="otherQuestionStr" @click="showDetail(16)">市价委托和限价委托的区别是什么</div>
      <div class="otherQuestionStr" @click="showDetail(17)">为何委托后一直没有成交</div>
      <div class="otherQuestionStr" @click="showDetail(18)">什么情况下可以委托撤单</div>
      <div class="otherQuestionStr" @click="showDetail(19)">送股是什么</div>
      <div class="bgspace"></div>
    </div>

    <div id="an13" style="display:none">
      <div class="answerTitle">股票开市收市时间是怎样的</div>
      <div
        class="answerContet"
      >股票交易时间为交易日每周一至周五。国家法定假日和本所公告的休市日，本所市场休市。上交所：采用竞价交易方式的，每个交易日的9:15至9:25为开盘集合竞价时间，9:30至11:30、13:00至15:00为连续竞价时间。深交所：采用竞价交易方式，采用竞价交易方式的，每个交易日的9:15至9:25为开盘集合竞价时间，9:30至11:30、13:00至14:57为连续竞价时间，14:57至15:00为收盘集合竞价时间。</div>
      <div class="otherQuestion">其他问题</div>
      <div class="otherQuestionStr" @click="showDetail(10)">开盘价是什么</div>
      <div class="otherQuestionStr" @click="showDetail(11)">收盘价是什么</div>
      <div class="otherQuestionStr" @click="showDetail(12)">股票9:30之前的集合竞价的交易规则是怎样的</div>
      <div class="otherQuestionStr" @click="showDetail(14)">为什么会有委托价和成交价不一致的情况</div>
      <div class="otherQuestionStr" @click="showDetail(15)">股票成交的时间优先、价格优先原则是指什么</div>
      <div class="otherQuestionStr" @click="showDetail(16)">市价委托和限价委托的区别是什么</div>
      <div class="otherQuestionStr" @click="showDetail(17)">为何委托后一直没有成交</div>
      <div class="otherQuestionStr" @click="showDetail(18)">什么情况下可以委托撤单</div>
      <div class="otherQuestionStr" @click="showDetail(19)">送股是什么</div>
      <div class="bgspace"></div>
    </div>

    <div id="an14" style="display:none">
      <div class="answerTitle">为什么会有委托价和成交价不一致的情况</div>
      <div class="answerContet">
        主要有以下几种情况：
        1、在参加集合竞价时，如果买入申报价格高于集合竞价产生的成交价，或卖出申报价格低于集合竞价产生的成交价，则按集合竞价产生的成交价；
        2、在参加连续竞价时，当委托买入申报价格高于市场即时的最低卖出申报价格时，取即时揭示的最低卖出申报价为其成交价。
        3、在参加连续竞价时，当委托卖出申报价格低于市场即时的最高买入申报价格时，取即时揭示的最高买入申报价为其成交价。
      </div>
      <div class="otherQuestion">其他问题</div>
      <div class="otherQuestionStr" @click="showDetail(10)">开盘价是什么</div>
      <div class="otherQuestionStr" @click="showDetail(11)">收盘价是什么</div>
      <div class="otherQuestionStr" @click="showDetail(12)">股票9:30之前的集合竞价的交易规则是怎样的</div>
      <div class="otherQuestionStr" @click="showDetail(13)">股票开市收市时间是怎样的</div>
      <div class="otherQuestionStr" @click="showDetail(15)">股票成交的时间优先、价格优先原则是指什么</div>
      <div class="otherQuestionStr" @click="showDetail(16)">市价委托和限价委托的区别是什么</div>
      <div class="otherQuestionStr" @click="showDetail(17)">为何委托后一直没有成交</div>
      <div class="otherQuestionStr" @click="showDetail(18)">什么情况下可以委托撤单</div>
      <div class="otherQuestionStr" @click="showDetail(19)">送股是什么</div>
      <div class="bgspace"></div>
    </div>

    <div id="an15" style="display:none">
      <div class="answerTitle">股票成交的时间优先、价格优先原则是指什么</div>
      <div class="answerContet">
        时间优先原则：买卖方向、价格相同的，先申报者优先于后申报者成交。先后顺序按交易主机接受申报的时间确定。
        价格优先原则：较高价格的买入申报优先于较低价格的买入申报成交，较低价格的卖出申报优先于较高价格的卖出申报成交。
      </div>
      <div class="otherQuestion">其他问题</div>
      <div class="otherQuestionStr" @click="showDetail(10)">开盘价是什么</div>
      <div class="otherQuestionStr" @click="showDetail(11)">收盘价是什么</div>
      <div class="otherQuestionStr" @click="showDetail(12)">股票9:30之前的集合竞价的交易规则是怎样的</div>
      <div class="otherQuestionStr" @click="showDetail(13)">股票开市收市时间是怎样的</div>
      <div class="otherQuestionStr" @click="showDetail(14)">为什么会有委托价和成交价不一致的情况</div>
      <div class="otherQuestionStr" @click="showDetail(16)">市价委托和限价委托的区别是什么</div>
      <div class="otherQuestionStr" @click="showDetail(17)">为何委托后一直没有成交</div>
      <div class="otherQuestionStr" @click="showDetail(18)">什么情况下可以委托撤单</div>
      <div class="otherQuestionStr" @click="showDetail(19)">送股是什么</div>
      <div class="bgspace"></div>
    </div>

    <div id="an16" style="display:none">
      <div class="answerTitle">市价委托和限价委托的区别是什么</div>
      <div class="answerContet">
        市价委托是指客户委托券商按市场价格买卖证券。即：客户无需设定价格，只需选择市价委托的申报类型，下单后由交易所进行撮合成交，只有在成交后，客户才能查询到成交价格的一种委托方式。市价委托只适用于有价格涨跌幅限制证券连续竞价期间的交易。（非交易时间和集合竞价期间下市价委托会废单，因为交易主机不接受市价申报）。
        限价委托是指客户委托券商按其限定的价格买卖证券，券商必须按限定的价格或低于限定的价格申报买入证券；按限定的价格或高于限定的价格申报卖出证券。
      </div>
      <div class="otherQuestion">其他问题</div>
      <div class="otherQuestionStr" @click="showDetail(10)">开盘价是什么</div>
      <div class="otherQuestionStr" @click="showDetail(11)">收盘价是什么</div>
      <div class="otherQuestionStr" @click="showDetail(12)">股票9:30之前的集合竞价的交易规则是怎样的</div>
      <div class="otherQuestionStr" @click="showDetail(13)">股票开市收市时间是怎样的</div>
      <div class="otherQuestionStr" @click="showDetail(14)">为什么会有委托价和成交价不一致的情况</div>
      <div class="otherQuestionStr" @click="showDetail(15)">股票成交的时间优先、价格优先原则是指什么</div>
      <div class="otherQuestionStr" @click="showDetail(17)">为何委托后一直没有成交</div>
      <div class="otherQuestionStr" @click="showDetail(18)">什么情况下可以委托撤单</div>
      <div class="otherQuestionStr" @click="showDetail(19)">送股是什么</div>
      <div class="bgspace"></div>
    </div>

    <div id="an17" style="display:none">
      <div class="answerTitle">为何委托后一直没有成交</div>
      <div class="answerContet">
        1、建议在委托查询里检查是否是无效委托；
        2、由于存在时间差，委托报入交易所主机时价格已发生变化从而导致未成交；
        3、申报时间内未有与之匹配的交易。
      </div>
      <div class="otherQuestion">其他问题</div>
      <div class="otherQuestionStr" @click="showDetail(10)">开盘价是什么</div>
      <div class="otherQuestionStr" @click="showDetail(11)">收盘价是什么</div>
      <div class="otherQuestionStr" @click="showDetail(12)">股票9:30之前的集合竞价的交易规则是怎样的</div>
      <div class="otherQuestionStr" @click="showDetail(13)">股票开市收市时间是怎样的</div>
      <div class="otherQuestionStr" @click="showDetail(14)">为什么会有委托价和成交价不一致的情况</div>
      <div class="otherQuestionStr" @click="showDetail(15)">股票成交的时间优先、价格优先原则是指什么</div>
      <div class="otherQuestionStr" @click="showDetail(16)">市价委托和限价委托的区别是什么</div>
      <div class="otherQuestionStr" @click="showDetail(18)">什么情况下可以委托撤单</div>
      <div class="otherQuestionStr" @click="showDetail(19)">送股是什么</div>
      <div class="bgspace"></div>
    </div>

    <div id="an18" style="display:none">
      <div class="answerTitle">什么情况下可以委托撤单</div>
      <div class="answerContet">在委托未成交之前，投资者可以撤销委托。</div>
      <div class="otherQuestion">其他问题</div>
      <div class="otherQuestionStr" @click="showDetail(10)">开盘价是什么</div>
      <div class="otherQuestionStr" @click="showDetail(11)">收盘价是什么</div>
      <div class="otherQuestionStr" @click="showDetail(12)">股票9:30之前的集合竞价的交易规则是怎样的</div>
      <div class="otherQuestionStr" @click="showDetail(13)">股票开市收市时间是怎样的</div>
      <div class="otherQuestionStr" @click="showDetail(14)">为什么会有委托价和成交价不一致的情况</div>
      <div class="otherQuestionStr" @click="showDetail(15)">股票成交的时间优先、价格优先原则是指什么</div>
      <div class="otherQuestionStr" @click="showDetail(16)">市价委托和限价委托的区别是什么</div>
      <div class="otherQuestionStr" @click="showDetail(17)">为何委托后一直没有成交</div>
      <div class="otherQuestionStr" @click="showDetail(19)">送股是什么</div>
      <div class="bgspace"></div>
    </div>
    <div id="an19" style="display:none">
      <div class="answerTitle">送股是什么</div>
      <div
        class="answerContet"
      >即将股票红利分配给股东。在上市公司分红时，我国股民普遍都偏好送红股。其实对上市公司来说，在给股东分红时采取送红股的方式，与完全不分红、将利润滚存至下一年度等方式~并没有什么区别。这几种方式，都是把应分给股东的利润留在企业作为下一年度发展生产所用的资金。它一方面增强了上市公司的经营实力，进一步扩大了企业的生产经营规模，另一方面它不象现金分红那样需要拿出较大额度的现金来应付派息工作，因为企业一般留存的现金都是不太多的。所以这几种形式对上市公司来说都是较为有利的.当上市公司不给股东分红或将利润滚存至下一年时，这部分利润就以资本公积金的形式记录在资产负债表中。而给股东送红股时，这一部分利润就要作为追加的股本记录在股本金中，成为股东权益的一部分。但在送红股时，因为上市公司的股本发生了变化，一方面上市公司需到当地的工商管理机构进行重新注册登记另外还需对外发布股本变动的公告。</div>
      <div class="otherQuestion">其他问题</div>
      <div class="otherQuestionStr" @click="showDetail(10)">开盘价是什么</div>
      <div class="otherQuestionStr" @click="showDetail(11)">收盘价是什么</div>
      <div class="otherQuestionStr" @click="showDetail(12)">股票9:30之前的集合竞价的交易规则是怎样的</div>
      <div class="otherQuestionStr" @click="showDetail(13)">股票开市收市时间是怎样的</div>
      <div class="otherQuestionStr" @click="showDetail(14)">为什么会有委托价和成交价不一致的情况</div>
      <div class="otherQuestionStr" @click="showDetail(15)">股票成交的时间优先、价格优先原则是指什么</div>
      <div class="otherQuestionStr" @click="showDetail(16)">市价委托和限价委托的区别是什么</div>
      <div class="otherQuestionStr" @click="showDetail(17)">为何委托后一直没有成交</div>
      <div class="otherQuestionStr" @click="showDetail(18)">什么情况下可以委托撤单</div>
      <div class="bgspace"></div>
    </div>
  </div>
</template>
<script>
export default {
    data() {
    return {
      showid:'',
      query:'',
      vars:[],
      pair:[],
    //   showG:true  
    display: ""
    };
  },mounted(){
      this.initAnswer();  
  },
    methods:{
         showDetail(id){
            document.querySelector("#an"+id).style.display="block";
            if(this.showid!=""){ 
            document.querySelector("#an"+this.showid).style.display= "none";
            this.showid=id;
            }
        },initAnswer(){
    
            this.showid=this.$route.params.id;
            if(this.showid && this.showid!=""){
                // this.display="";
                document.querySelector("#an"+this.showid).style.display="block";
            }
        },getQueryVariable(variable){
            this.query = window.location.search.substring(1);
            this.vars = this.query.split("&");
            for (var i=0;i<this.vars.length;i++) {
                this.pair = this.vars[i].split("=");
               if(this.pair[0] == variable){return this.pair[1];}
            }
            return(false);
        }
    }
}
</script>
<style>
body {
  height: 100%;
  padding: 0;
  margin: 0;
}
</style>
<style lang="less" >
@import "./style/helpIndex.less";
</style>